import React, { PureComponent } from 'react';
import _Swiper from 'swiper/dist/js/swiper.js';
import 'swiper/dist/css/swiper.min.css';
import './index.scss';
import PropTypes from 'prop-types';

export default class Swiper extends PureComponent {
  static propTypes = {
    articleInfo: PropTypes.array
  };

  componentDidMount() {
    new _Swiper('.swiper-container', {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      autoplay: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  }

  render() {
    const { articleInfo, headBackground } = this.props;
    console.log(headBackground);

    const bannerUrl =
      headBackground && headBackground !== ''
        ? headBackground
        : 'http://imgcdn.lanxiongsports.com/upload/topic-admin/banner_bg.jpg';

    return (
      <div
        className="_swiper-wrapper"
        style={{
          background: `url(${bannerUrl}) center center no-repeat`,
          backgroundSize: 'cover'
        }}
      >
        <div className="wrapper">
          <div className="swiper-container">
            <div className="swiper-wrapper">
              {articleInfo.map(item => (
                <div className="swiper-slide" key={item.articleTittle}>
                  <a href={item.linkUrl} alt={item.articleTittle}>
                    <img src={item.articlePic} alt="" />
                    <p>{item.articleTittle}</p>
                  </a>
                </div>
              ))}
            </div>
          </div>
          <div className="swiper-button-next swiper-button-white" />
          <div className="swiper-button-prev swiper-button-white" />
          <div className="swiper-pagination" />
        </div>
      </div>
    );
  }
}
